<ac-card>
  <ac-card-content>
    <div class="purchase-dialog">
      @switch (purchase().purchase_status) { @case('complete') {
      <app-purchase-dialog-header
        title="Purchase Complete"
        [hideBack]="true"
        (close)="close.emit()"
      />
      } @case('failed') {
      <app-purchase-dialog-header
        title="Purchase Failed"
        [hideBack]="true"
        (close)="close.emit()"
      />
      } @case('blocked') {
      <app-purchase-dialog-header
        title="Purchase Under Review"
        [hideBack]="true"
        (close)="close.emit()"
      />
      } @default {
      <app-purchase-dialog-header
        title="Purchase in Progress"
        [hideBack]="true"
        (close)="close.emit()"
      />
      } }
      <app-payment-status-indicator [status]="purchase().purchase_status" />
      <ul class="purchase-dialog__crypto-confirm-table ac-body-md">
        @if (purchase().purchase_status !== 'blocked') {
        @if (currentCurrency(); as currency) {
        <li>
          <div class="purchase-dialog__crypto-confirm-table-key">Asset</div>
          <div class="purchase-dialog__crypto-confirm-table-value">
            <div class="ac-flex-ctr purchase-dialog__crypto-confirm-table-icon">
              <ac-icon [iconKey]="currency.ui_icon" [size]="16" />
            </div>
            <div>
              {{
                currency.ui_label ?? currency.display_name
              }}
              <span class="ac-label">{{ currency.ticker }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="purchase-dialog__crypto-confirm-table-key">Amount</div>
          <div class="purchase-dialog__crypto-confirm-table-value">
            <div>
              {{
                purchase().amount
                  | decimal
                    : currency.ui_decimals +
                        '-' +
                        currency.ui_decimals
              }}
              {{ currency.ticker }}
            </div>
            @if (actualPaidUsd() !== null) {
            <div class="ac-label ac-body-lg">
              ({{ actualPaidUsd() | currency : 'USD' : 'symbol-narrow' }})
            </div>
            }
          </div>
        </li>
        }
        <li>
          <div class="purchase-dialog__crypto-confirm-table-key">
            Time & Date
          </div>
          <div class="purchase-dialog__crypto-confirm-table-value">
            <div>
              {{
                purchase().updated_at_by_provider
                  | date : 'MMMM d, yyyy • h:mm a'
              }}
            </div>
          </div>
        </li>
        <li>
          <div class="purchase-dialog__crypto-confirm-table-key">Status</div>
          <div class="purchase-dialog__crypto-confirm-table-value">
            <div
              class="purchase-dialog__pill purchase-dialog__pill--{{
                purchase().purchase_status
              }}"
            >
              {{ purchase().confirmations }} Confirmation{{
                purchase().confirmations !== 1 ? 's' : ''
              }}
            </div>
          </div>
        </li>
        <li>
          <div class="purchase-dialog__crypto-confirm-table-key">
            Blockchain Link
          </div>
          <div class="purchase-dialog__crypto-confirm-table-value">
            <a
              target="_blank"
              [href]="
                purchase().transaction_hash!
                  | blockchainUrl : purchase()!.blockchain_id! : 'tx'
              "
              class="purchase-dialog__link ac-title-md"
            >
              View in Explorer
              <ac-icon iconKey="payment:external_link" [size]="16" />
            </a>
          </div>
        </li>
        } @else {
        <li>
          <div class="purchase-dialog__crypto-confirm-table-key">Total</div>
          <div class="purchase-dialog__crypto-confirm-table-value">
            <div>
              @if (actualPaidUsd() !== null) {
              {{ actualPaidUsd() | currency : 'USD' : 'symbol-narrow' }} USD
              } @else {
              &mdash;
              }
            </div>
          </div>
        </li>
        <li>
          <div class="purchase-dialog__crypto-confirm-table-key">Status</div>
          <div class="purchase-dialog__crypto-confirm-table-value">
            <div class="purchase-dialog__pill purchase-dialog__pill--blocked">
              Under Review
            </div>
          </div>
        </li>
        <li>
          <div class="purchase-dialog__crypto-confirm-table-key">
            Time & Date
          </div>
          <div class="purchase-dialog__crypto-confirm-table-value">
            <div>
              {{
                purchase().updated_at_by_provider
                  | date : 'MMMM d, yyyy • h:mm a'
              }}
            </div>
          </div>
        </li>
        }
      </ul>
      @if (purchase().purchase_status === 'blocked') {
      <div class="purchase-dialog__footer">
        <div class="purchase-dialog__footer-text ac-body-sm">
          Have a question about this?
          <a class="ac-link ac-title-sm" (click)="close.emit('contact-support')"
            >Contact Support</a
          >
        </div>
      </div>
      }
    </div>
  </ac-card-content>
</ac-card>
